export default function ColumnLeft(props){
    return <div className="bg-[#EEF1F9] lg:flex items-center justify-center hidden">
        {props.children}
    </div>
}